import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { DbContextService } from '../../../services/db-context.service';
import { Helper } from '../../common/helper';
import swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class DailyMealsEntryService {

  constructor(private http: HttpClient, private dbxService: DbContextService) { }

  getDailyMealsReferences(): Observable<any[]> {
    let crewTypes = this.http.get(Helper.API_URL() + '/api/Maintenance/GetCrewTypeList');
    let meals = this.http.get(Helper.API_URL() + '/api/Maintenance/GetMealsList')
    let subCrewTypes = this.http.get(Helper.API_URL() + '/api/Maintenance/GetShipDailyMealsSetCrewSubTypeList');

    return forkJoin([crewTypes, meals, subCrewTypes]);
  }

  getShipsManagerShowNightMeals(shipsManagerOwnerID: number) {
    // convert to httpPost
    let paramObject = {
      'shipsManagerOwnerID': shipsManagerOwnerID
    }

    return this.http.post(Helper.API_URL() + '/api/ShipOwner/GetShipsManagerShowNightMeals', paramObject);
  }

  getActiveContract(departmentID: number) {

    // convert to httpPost
    let paramObject = {
      'departmentID': departmentID
    }

    return this.http.post(Helper.API_URL() + '/api/Budget/GetActiveContract', paramObject);
  }

  getDailyMealsAndFeesAndDetails(dailyMealsAndFeesID: any): Observable<any[]> {
    let dailyMealsAndFees = this.http.get(Helper.API_URL() + '/api/Budget/GetDailyMealsAndFees/' + dailyMealsAndFeesID);
    let dailyMealsAndFeesDetails = this.http.get(Helper.API_URL() + '/api/Budget/GetDailyMealsAndFeesDetails/' + dailyMealsAndFeesID);

    return forkJoin([dailyMealsAndFees, dailyMealsAndFeesDetails]);
  }

  createDailyMealsAndFeesAndDetails(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Budget/CreateDailyMealsAndFeesAndDetails', data);
  }

  updateDailyMealsAndFeesAndDetails(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Budget/UpdateDailyMealsAndFeesAndDetails', data);
  }

  approveDailyMealsMonthSummary(data: any) {
    return this.http.post(Helper.API_URL() + '/api/budget/ApproveDailyMealsAndFees', data);
  }

  saveDailyMealsAndFeesTempData(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Budget/SaveDailyMealsAndFeesTempData', data);
  }

  getDailyMealsAndFeesIndexDb(dailyMealsAndFeesKey: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblDailyMealsAndFees', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblDailyMealsAndFees');
        store.get(dailyMealsAndFeesKey).then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });

    return promise;
  }

  getAllDailyMealsAndFeesIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblDailyMealsAndFees', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblDailyMealsAndFees');
        store.getAll().then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });

    return promise;
  }

  getDailyMealsAndFeesDetailsIndexDb(dailyMealsAndFeesKey: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblDailyMealsAndFeesDetails', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblDailyMealsAndFeesDetails');
        store.get(dailyMealsAndFeesKey).then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });

    return promise;
  }

  getAllDailyMealsAndFeesDetailsIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblDailyMealsAndFeesDetails', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblDailyMealsAndFeesDetails');
        store.getAll().then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });

    return promise;
  }

  saveDailyMealsAndFeesIndexDb(dailyMealsAndFees: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      const obj = {
        dailyMealsAndFeesID: dailyMealsAndFees.dailyMealsAndFeesID,
        beginDate: dailyMealsAndFees.beginDate,
        endDate: dailyMealsAndFees.endDate,
        days: dailyMealsAndFees.days,
        averageMenPerDay: dailyMealsAndFees.averageMenPerDay,
        specialAverageMenPerDay: dailyMealsAndFees.specialAverageMenPerDay,
        extraAverageMenPerDay: dailyMealsAndFees.extraAverageMenPerDay,
        isApproved: dailyMealsAndFees.isApproved,
        isSubmitted: dailyMealsAndFees.isSubmitted,
        lastSavedHash: dailyMealsAndFees.lastSavedHash,
        isChangedLastSave: dailyMealsAndFees.isChangedLastSave
      };

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblDailyMealsAndFees', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };
        let store = tx.objectStore('OWS_tblDailyMealsAndFees');

        try {
          let req = store.add(obj).then(
            (res: any) => {
              resolve(res);
            }
          )
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }

        return tx.done;// complete;
      });

    });
    return promise;
  }

  saveDailyMealsAndFeesDetailsIndexDb(dailyMealsAndFeesDetails: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      const obj = {
        //dailyMealsAndFeesID: dailyMealsAndFeesDetails.dailyMealsAndFeesID, // if saving in one record, uncomment this and comment remaining below
        //dailyMealsAndFeesDetails: dailyMealsAndFeesDetails.dailyMealsAndFeesDetails // if saving in one record, uncomment this and comment remaining below
        dailyMealsAndFeesDetailsID: dailyMealsAndFeesDetails.dailyMealsAndFeesDetailsID,
        dailyMealsAndFeesID: dailyMealsAndFeesDetails.dailyMealsAndFeesID,
        beginDate: dailyMealsAndFeesDetails.beginDate,
        endDate: dailyMealsAndFeesDetails.endDate,
        crewSubTypeDesc: dailyMealsAndFeesDetails.crewSubTypeDesc,
        crewSubTypeID: dailyMealsAndFeesDetails.crewSubTypeID,
        crewTypeDesc: dailyMealsAndFeesDetails.crewTypeDesc,
        crewTypeID: dailyMealsAndFeesDetails.crewTypeID,
        crewTypeSeq: dailyMealsAndFeesDetails.crewTypeSeq,
        mealDesc: dailyMealsAndFeesDetails.mealDesc,
        mealID: dailyMealsAndFeesDetails.mealID,
        day1: dailyMealsAndFeesDetails.day1,
        day2: dailyMealsAndFeesDetails.day2,
        day3: dailyMealsAndFeesDetails.day3,
        day4: dailyMealsAndFeesDetails.day4,
        day5: dailyMealsAndFeesDetails.day5,
        day6: dailyMealsAndFeesDetails.day6,
        day7: dailyMealsAndFeesDetails.day7,
        day8: dailyMealsAndFeesDetails.day8,
        day9: dailyMealsAndFeesDetails.day9,
        day10: dailyMealsAndFeesDetails.day10,
        day11: dailyMealsAndFeesDetails.day11,
        day12: dailyMealsAndFeesDetails.day12,
        day13: dailyMealsAndFeesDetails.day13,
        day14: dailyMealsAndFeesDetails.day14,
        day15: dailyMealsAndFeesDetails.day15,
        day16: dailyMealsAndFeesDetails.day16,
        day17: dailyMealsAndFeesDetails.day17,
        day18: dailyMealsAndFeesDetails.day18,
        day19: dailyMealsAndFeesDetails.day19,
        day20: dailyMealsAndFeesDetails.day20,
        day21: dailyMealsAndFeesDetails.day21,
        day22: dailyMealsAndFeesDetails.day22,
        day23: dailyMealsAndFeesDetails.day23,
        day24: dailyMealsAndFeesDetails.day24,
        day25: dailyMealsAndFeesDetails.day25,
        day26: dailyMealsAndFeesDetails.day26,
        day27: dailyMealsAndFeesDetails.day27,
        day28: dailyMealsAndFeesDetails.day28,
        day29: dailyMealsAndFeesDetails.day29,
        day30: dailyMealsAndFeesDetails.day30,
        day31: dailyMealsAndFeesDetails.day31
      };

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblDailyMealsAndFeesDetails', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        let store = tx.objectStore('OWS_tblDailyMealsAndFeesDetails');
        try {
          let req = store.add(obj).then(
            (res: any) => {
              resolve(res);
            }
          )
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }
        return tx.done;// complete;
      });

    });
    return promise;
  }

  updateDailyMealsAndFeesIndexDb(dailyMealsAndFees: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      const obj = {
        dailyMealsAndFeesID: dailyMealsAndFees.dailyMealsAndFeesID,
        beginDate: dailyMealsAndFees.beginDate,
        endDate: dailyMealsAndFees.endDate,
        days: dailyMealsAndFees.days,
        averageMenPerDay: dailyMealsAndFees.averageMenPerDay,
        specialAverageMenPerDay: dailyMealsAndFees.specialAverageMenPerDay,
        extraAverageMenPerDay: dailyMealsAndFees.extraAverageMenPerDay,
        isApproved: dailyMealsAndFees.isApproved,
        isSubmitted: dailyMealsAndFees.isSubmitted,
        isUpdatedOffline: dailyMealsAndFees.isUpdatedOffline,
        lastSavedHash: dailyMealsAndFees.lastSavedHash,
        isChangedLastSave: dailyMealsAndFees.isChangedLastSave
      };

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblDailyMealsAndFees', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };
        let store = tx.objectStore('OWS_tblDailyMealsAndFees');
        try {
          let req = store.put(obj).then(
            (res: any) => {
              resolve(res);
            }
          );
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }

        return tx.done;// complete;
      });
    });

    return promise;
  }

  updateDailyMealsAndFeesDetailsIndexDb(dailyMealsAndFeesDetails: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      //const obj = {
      //  //dailyMealsAndFeesID: dailyMealsAndFeesDetails.dailyMealsAndFeesID, // if saving in one record, uncomment this and comment remaining below
      //  //dailyMealsAndFeesDetails: dailyMealsAndFeesDetails.dailyMealsAndFeesDetails // if saving in one record, uncomment this and comment remaining below
      //  dailyMealsAndFeesDetailsID: dailyMealsAndFeesDetails.dailyMealsAndFeesDetailsID,
      //  dailyMealsAndFeesID: dailyMealsAndFeesDetails.dailyMealsAndFeesID,
      //  beginDate: dailyMealsAndFeesDetails.beginDate,
      //  endDate: dailyMealsAndFeesDetails.endDate,
      //  crewSubTypeDesc: dailyMealsAndFeesDetails.crewSubTypeDesc,
      //  crewSubTypeID: dailyMealsAndFeesDetails.crewSubTypeID,
      //  crewTypeDesc: dailyMealsAndFeesDetails.crewTypeDesc,
      //  crewTypeID: dailyMealsAndFeesDetails.crewTypeID,
      //  crewTypeSeq: dailyMealsAndFeesDetails.crewTypeSeq,
      //  mealDesc: dailyMealsAndFeesDetails.mealDesc,
      //  mealID: dailyMealsAndFeesDetails.mealID,
      //  day1: dailyMealsAndFeesDetails.day1,
      //  day2: dailyMealsAndFeesDetails.day2,
      //  day3: dailyMealsAndFeesDetails.day3,
      //  day4: dailyMealsAndFeesDetails.day4,
      //  day5: dailyMealsAndFeesDetails.day5,
      //  day6: dailyMealsAndFeesDetails.day6,
      //  day7: dailyMealsAndFeesDetails.day7,
      //  day8: dailyMealsAndFeesDetails.day8,
      //  day9: dailyMealsAndFeesDetails.day9,
      //  day10: dailyMealsAndFeesDetails.day10,
      //  day11: dailyMealsAndFeesDetails.day11,
      //  day12: dailyMealsAndFeesDetails.day12,
      //  day13: dailyMealsAndFeesDetails.day13,
      //  day14: dailyMealsAndFeesDetails.day14,
      //  day15: dailyMealsAndFeesDetails.day15,
      //  day16: dailyMealsAndFeesDetails.day16,
      //  day17: dailyMealsAndFeesDetails.day17,
      //  day18: dailyMealsAndFeesDetails.day18,
      //  day19: dailyMealsAndFeesDetails.day19,
      //  day20: dailyMealsAndFeesDetails.day20,
      //  day21: dailyMealsAndFeesDetails.day21,
      //  day22: dailyMealsAndFeesDetails.day22,
      //  day23: dailyMealsAndFeesDetails.day23,
      //  day24: dailyMealsAndFeesDetails.day24,
      //  day25: dailyMealsAndFeesDetails.day25,
      //  day26: dailyMealsAndFeesDetails.day26,
      //  day27: dailyMealsAndFeesDetails.day27,
      //  day28: dailyMealsAndFeesDetails.day28,
      //  day29: dailyMealsAndFeesDetails.day29,
      //  day30: dailyMealsAndFeesDetails.day30,
      //  day31: dailyMealsAndFeesDetails.day31
      //};

      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblDailyMealsAndFeesDetails', 'readwrite');
        tx.oncomplete = (ev) => {

        }
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };
        let store = tx.objectStore('OWS_tblDailyMealsAndFeesDetails');
        try {
          let req = store.put(dailyMealsAndFeesDetails).then(
            (res: any) => {
              resolve(res);
            }
          );
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }

        return tx.done;// complete;
      });
    });

    return promise;
  }

  deleteDMFDetailsByDMFIDIndexDb(dailyMealsAndFeesId: any): Promise<Object> {
    let promise = new Promise<any>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDailyMealsAndFeesDetails', 'readwrite');
        let store = tx.objectStore('OWS_tblDailyMealsAndFeesDetails');

        store.getAll().then((res: any) => {
          if (res) {
            if (res.length > 0) {
              let dmfDetails = res.filter((x: any) => x.dailyMealsAndFeesID == dailyMealsAndFeesId);
              dmfDetails.forEach((dm: any) => {
                store.delete(dm.dailyMealsAndFeesDetailsID);
              })

              resolve(res);
            } else {
              resolve(null);
            }
          } else {
            resolve(null);
          }
        })
      })
    });

    return promise;
  }

  deleteDMFDetailsByDMFDetailsIDIndexDb(dailyMealsAndFeesDetailsId: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDailyMealsAndFeesDetails', 'readwrite');
        let store = tx.objectStore('OWS_tblDailyMealsAndFeesDetails');

        store.delete(dailyMealsAndFeesDetailsId).then(
          (res: any) => {
            resolve(res);
          }
        );
      })
    });

    return promise;
  }

  deleteNewDailyMealsAndFeesDetailsIndexDb(dailyMealsAndFeesId: any): Promise<Object> {
    let promise = new Promise<any>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDailyMealsAndFeesDetails', 'readwrite');
        let store = tx.objectStore('OWS_tblDailyMealsAndFeesDetails');

        store.getAll().then((res: any) => {
          if (res) {
            if (res.length > 0) {
              let dmfDetails = res.filter((x: any) => x.dailyMealsAndFeesID == dailyMealsAndFeesId);
              dmfDetails.forEach((dm: any) => {
                if (dm.dailyMealsAndFeesDetailsID < 0) {
                  store.delete(dm.dailyMealsAndFeesDetailsID);
                }
                resolve(null);
              })

            } else {
              resolve(false);
            }
          } else {
            resolve(false);
          }
        })
      })
    });

    return promise;
  }

  markSubmittedDMOverviewIndexDb(dmfId: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDailyMealsAndFees', 'readwrite');
        let store = tx.objectStore('OWS_tblDailyMealsAndFees');
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        store.get(dmfId).then((res: any) => {
          if (res != null) {
            res.isApproved = false;
            res.isSubmitted = true;
            res.isUpdatedOffline = true;

            let tx2 = db.transaction('OWS_tblDMOverviewSubmitted', 'readwrite');
            let store2 = tx2.objectStore('OWS_tblDMOverviewSubmitted');

            try {
              store2.put(res).then(
                (response: any) => {
                  resolve(response);
                }
              );
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }

          }
        })
      })
    });

    return promise;
  }

  markApprovedDMOverviewIndexDb(dmfId: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblDailyMealsAndFees', 'readwrite');
        let store = tx.objectStore('OWS_tblDailyMealsAndFees');

        store.get(dmfId).then((res: any) => {
          let dmf = Helper.deepCopy(res);
          if (res != null) {

            let tx2 = db.transaction('OWS_tblDMOverviewSubmitted', 'readwrite');
            let store2 = tx2.objectStore('OWS_tblDMOverviewSubmitted');
            store2.delete(dmfId);

            dmf.isApproved = true;
            dmf.isSubmitted = true;
            dmf.isUpdatedOffline = true;
            dmf.uploaded = true;

            let tx3 = db.transaction('OWS_tblDMOverviewApproved', 'readwrite');
            let store3 = tx3.objectStore('OWS_tblDMOverviewApproved');
            tx3.onabort = (event: any) => {
              const err = event.target?.error;
              if (err?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            };

            tx3.onerror = (event: any) => {
              console.warn(event);
              const err = event.target?.error;
              if (err?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            };

            try {
              store3.add(dmf).then(
                (response: any) => {
                  resolve(response);
                }
              );
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }

          }
        })
      })
    });

    return promise;
  }

  getActiveContractsIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblContracts', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblContracts');
        store.getAll().then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });

    return promise;
  }

  getCrewTypesIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblDMCrewTypes', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblDMCrewTypes');
        store.getAll().then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });

    return promise;
  }

  getCrewSubTypesIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblDMCrewSubTypes', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblDMCrewSubTypes');
        store.getAll().then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });

    return promise;
  }

  getMealsIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblMeals', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblMeals');
        store.getAll().then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });

    return promise;
  }

  getDMSubmittedIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblDMOverviewSubmitted', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblDMOverviewSubmitted');
        store.getAll().then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });

    return promise;
  }

  getDMApprovedIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblDMOverviewApproved', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblDMOverviewApproved');
        store.getAll().then(
          (res: any) => {
            resolve(res);
          }
        )
      });

    });

    return promise;
  }

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }
}
